import * as React from 'react';
import { forwardRef } from 'react';
import { Margin, HeadlineLevel} from 'features/ui/enums';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    headline: string;
    children: React.ReactNode;
}

export const ResidenceFilterSection = forwardRef<HTMLDivElement, Props>(({headline, children}, ref) => {
    return (
        <div className="residence-filter-form__section" ref={ref}>
            <Headline level={HeadlineLevel.H5} margin={Margin.L}>{headline}</Headline>
            {children}
        </div>
    )
});